import { Component, inject } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { ActivatedRoute } from '@angular/router'
import { GetProductTransactionsGQL } from '@ziptility/graphql'
import { ProductItemSelectorComponent } from '../inventory/product-selector/product-item-selector.component'
import { AssetProfileService } from './asset-profile.service'
import { ProductListItemComponent } from '@ziptility/inventory/product-selector'
import { firstValueFrom } from 'rxjs'

@Component({
  selector: 'feature-products',
  template: `
    <div class="flex flex-col h-full shadow-inner">
      <div class="flex-grow h-full px-12 py-5 overflow-auto">
        @for (event of vm.products(); track event) {
          <div class="w-full border-b border-gray-200 py-3 ">
            <product-list-item
              [productName]="event.name"
              [quantityDescription]="event.quantityDescription"
              [imageId]="event.imageId"
            ></product-list-item>
          </div>
        }
      </div>
      <div class="p-5 py-4 border-t border-gray-200">
        <button (click)="onAddProductUsed()" class="bv-submit-button w-full">Add product used</button>
      </div>
    </div>
  `,
  imports: [ProductListItemComponent],
})
export class FeatureProductsComponent {
  readonly route = inject(ActivatedRoute)
  readonly getProductTransactions = inject(GetProductTransactionsGQL)
  readonly matDialog = inject(MatDialog)
  readonly vm = inject(AssetProfileService)

  async onAddProductUsed() {
    const { featureId } = this.route.snapshot.params
    const ref = this.matDialog.open(ProductItemSelectorComponent, {
      height: '750px',
      width: '1000px',
      maxWidth: '1000px',
      maxHeight: '750px',
    })

    const result = await firstValueFrom(ref.afterClosed())
    if (!result) {
      return
    }

    await this.vm.consumeProducts(result, featureId)
  }
}
